import { GridAction } from '@eforall/dashboard';
import { Opportunity } from '@interfaces';


export function getActions() {

	const actions: GridAction<Opportunity>[] = [];

	return actions;
}